import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-thin-down",
  "use": "icon-arrow-thin-down-usage",
  "viewBox": "0 0 800 800",
  "content": "<symbol viewBox=\"0 0 800 800\" id=\"icon-arrow-thin-down\">\n  <defs>\n    <style>\n      #icon-arrow-thin-down .cls-1 {\n        fill: #010002;\n      }\n    </style>\n  </defs>\n  <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->\n  <g>\n    <g id=\"icon-arrow-thin-down_Layer_1\">\n      <g id=\"icon-arrow-thin-down_Layer_1-2\" data-name=\"Layer_1\">\n        <g id=\"icon-arrow-thin-down_Capa_1\">\n          <polygon class=\"cls-1\" points=\"661.6 538.4 640.8 517.6 414.7 743.7 414.7 0 385.3 0 385.3 743.7 159.2 517.6 138.4 538.4 400 800 661.6 538.4\" />\n        </g>\n      </g>\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-thin-down.svg
// module id = Behp
// module chunks = 107